<template>
  <div class="aaaaa">
    <div class="bbbbb">
    <!-- 头部部分 -->
    <div ref="search_d">
      <el-row class="row-bg">
        <el-form
          :model="queryInfo.condition"
          class="demo-form-inline"
          label-width="100px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="一级分类" prop="industryType">
                <el-select
                  v-model="queryInfo.condition.categoryFirstCode"
                  clearable
                  placeholder="请选择"
                  @change="change"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in menuList"
                    :key="item.categoryName"
                    :label="item.categoryName"
                    :value="item.categoryCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="二级分类">
                <el-input
                  v-model="queryInfo.condition.categorySecondName"
                  placeholder="二级分类"
                  style="width: 100%"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="queryInfo.condition.productName"
                  placeholder="商品名称"
                  style="width: 100%"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

<!--            <el-col :span="6">-->
<!--              <el-form-item label-width="20px">-->
<!--                <el-button type="primary" @click="getList" icon="el-icon-search"-->
<!--                >查询-->
<!--                </el-button-->
<!--                >-->
<!--                <el-button-->
<!--                  @click="reset"-->
<!--                  class="pull-right"-->
<!--                  icon="el-icon-refresh-left"-->
<!--                >重置-->
<!--                </el-button-->
<!--                >-->
<!--              </el-form-item>-->
<!--            </el-col>-->

          </el-row>
                    <el-row>
                                  <el-col :span="8">
                                    <el-form-item label="销售时间">
                                      <el-date-picker
                                        value-format="yyyy-MM-dd"
                                        v-model="value1"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        style="width: 100%"
                                        clearable
                                      >
                                      </el-date-picker>
                                    </el-form-item>
                                  </el-col>
                      <el-col :span="8">

                        <el-form-item label-width="50px">

                        <el-button type="primary" @click="getList" icon="el-icon-search"
                        >查询
                        </el-button
                        >
                        <el-button
                          @click="reset"
                          class="pull-right"
                          icon="el-icon-refresh-left"
                        >重置
                        </el-button
                        >
                        </el-form-item>

                      </el-col>
                    </el-row>

        </el-form>
      </el-row>
    </div>

    <!-- 表格部分 -->
    <div>
      <div class="tabTop">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="toExport"
        >导出
        </el-button
        >
      </div>
      <el-table
        border
        ref="table"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :height="height"
        v-loading="loading"
      >
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center"
        ></el-table-column>

        <!-- <el-table-column label="用户名称" align="center" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="用户头像" align="center" width="80px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.memberLogo"></el-avatar>
            </template>
          </el-table-column> -->
        <!-- <el-table-column label="支付单号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.payNo }}</template>
          </el-table-column> -->
        <el-table-column
          label="一级分类"
          width="180px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
              scope.row.categoryFirstName
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="二级分类"
          width="180px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
              scope.row.categorySecondName
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="商品名称"

          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.productName }}</template>
        </el-table-column>
        <el-table-column
          label="规格名称"

          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.skuName }}</template>
        </el-table-column>
        <el-table-column
          label="单件重量KG"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.netWeight }}</template>
        </el-table-column>
        <el-table-column
          label="数量"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.num }}</template>
        </el-table-column>
        <el-table-column
          label="小计重量KG"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.totalWeight }}</template>
        </el-table-column>
        <el-table-column
          label="单价(元)"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.sellPrice }}</template>
        </el-table-column>
        <el-table-column
          label="销售价格小计(元)"
          width="120px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.totalPrice }}</template>
        </el-table-column>
        <!-- <el-table-column label="供应商编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="供应商名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierName }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="站点编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.siteCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属站点" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.siteName }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属团长编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.teamCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属团长" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.teamName }}</template>
          </el-table-column> -->

        <!-- <el-table-column label="操作" width="135" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showOrderItemInfo(scope.row)" size="small">查看详情</el-button>
            <el-button type="text" @click="edit(scope.row)" size="small">打印小票</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    </div>
    <el-dialog
      :title="labelType == 'add' ? '新增' : '编辑'"
      :visible.sync="showDialog"
      width="800px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="：" prop="siteName">
              <el-input v-model="form.id" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户编码：" prop="siteName">
              <el-input
                v-model="form.memberCode"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="siteName">
              <el-input
                v-model="form.memberName"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户头像：" prop="siteName">
              <el-input
                v-model="form.memberLogo"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付单号：" prop="siteName">
              <el-input
                v-model="form.payNo"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号：" prop="siteName">
              <el-input
                v-model="form.orderNumber"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额：" prop="siteName">
              <el-input
                v-model="form.orderAmount"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商编码：" prop="siteName">
              <el-input
                v-model="form.supplierCode"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="siteName">
              <el-input
                v-model="form.supplierName"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点编码：" prop="siteName">
              <el-input
                v-model="form.siteCode"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点名称：" prop="siteName">
              <el-input
                v-model="form.siteName"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属团长编码：" prop="siteName">
              <el-input
                v-model="form.teamCode"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="：" prop="siteName">
              <el-input
                v-model="form.teamCod"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
        >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="订单详情" :visible.sync="dialogOrderItemVisible">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单详情" name="first">
          <el-container>
            <el-header>买家信息</el-header>
            <el-main
            >
              <div>
                用户头像:<span>
                  <el-avatar
                    shape="square"
                    :size="50"
                    :src="orderInfo.memberLogo"
                  ></el-avatar
                  ></span></div
              >
            </el-main>
            <el-main
            >
              <div>
                用户名称:<span>{{ orderInfo.memberName }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                用户手机号:<span>{{ orderInfo.memberPhone }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                收件人名称:<span>{{ orderInfo.recipientName }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                收件人手机号码:<span>{{ orderInfo.recipientPhone }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                收件人地址:<span
              >{{ orderInfo.provinceName }}{{
                  orderInfo.cityName
                }}{{
                  orderInfo.expAreaName
                }}{{ orderInfo.expressAddress }}</span
              >
              </div>
            </el-main
            >
          </el-container>
          <el-container>
            <el-header>团长信息</el-header>
            <el-main
            >
              <div>
                团长名称:<span>{{ orderInfo.teamName }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                团长手机号码:<span>{{ orderInfo.teamPhone }}</span>
              </div>
            </el-main
            >
          </el-container>

          <el-container>
            <el-header>订单信息</el-header>
            <el-main
            >
              <div>
                订单号:<span>{{ orderInfo.orderNumber }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                支付方式:<span>{{ getPayType(orderInfo.payType) }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                实际付款:<span>{{ orderInfo.actualAmount }}元</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                下单时间:<span>{{ orderInfo.orderTime }}</span>
              </div>
            </el-main
            >
            <el-main
            >
              <div>
                支付时间:<span>{{ orderInfo.orderTime }}</span>
              </div>
            </el-main
            >
          </el-container>

          <el-table :data="orderItemData">
            <el-table-column label="商品图片" width="150">
              <template slot-scope="scope">
                <el-avatar
                  shape="square"
                  :size="50"
                  :src="scope.row.listImg"
                ></el-avatar>
              </template>
            </el-table-column>
            <el-table-column
              property="productName"
              label="商品名称"
              width="200"
            ></el-table-column>
            <el-table-column
              property="sellPrice"
              label="售卖价"
            ></el-table-column>
            <el-table-column property="count" label="数量"></el-table-column>
            <el-table-column property="skuName" label="规格"></el-table-column>
            <el-table-column label="总价">
              <template slot-scope="scope">
                {{ scope.row.count * scope.row.sellPrice }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="订单进度" name="second">
          <el-table :data="orderProgressData">
            <el-table-column
              property="orderProgressName"
              label="进度"
              width="200"
            ></el-table-column>
            <el-table-column
              property="createTime"
              label="时间"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuList: [],
      secondLevelMenuList: [],
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      dialogOrderItemVisible: false,
      orderInfo: '',
      orderItemData: '',
      activeName: 'first',
      orderProgressData: '',
      value1: '',
      defaultTime: [],
      resizeHandler: null,
      loading: false
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义 ref 属性 和 元素高度
      if (this.$refs.search_d) {
        this.headerHeight = this.$refs.search_d.offsetHeight
      }

      // 添加 resize 事件监听器，并确保传递的是函数引用
      this.resizeHandler = this.getHeight.bind(this)
      window.addEventListener('resize', this.resizeHandler)
    })

    // 初始化日期范围
    // const end = new Date();
    // const start = new Date();
    // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);

    // this.value1 = [end, start];
    // this.defaultTime = [end, start];

    // 立即获取一次高度，以防 $nextTick 内的逻辑未能及时执行
    this.getHeight()
    this.getMenuList()
  },
  beforeDestroy () {
    // 移除 resize 事件监听器以防止内存泄漏
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },

    // 获取数据
    getList () {
      console.log(this.value1)
      console.log(this.value1[0])
      console.log(this.value1[1])

      this.loading = true

      var that = this
      if (this.value1[0] != undefined) {
        that.queryInfo.condition.startTime = this.value1[0] + ' 00:00:00'
      }
      if (this.value1[1] != undefined) {
        that.queryInfo.condition.endTime = this.value1[1] + ' 23:59:59'
      }
      that.$http
        .post('/orderItem/orderItemStatisticsList', that.queryInfo)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.loading = false
            that.total = response.data.data.count
            that.queryInfo.currPage = response.data.data.currPage
            that.tableData = response.data.data.data
          }
        })
    },

    // 保存
    handleSave () {
      var that = this
      that.$http
        .post('/order/save', that.form)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '保存成功',
              showClose: true
            })
            that.showDialog = false
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
        .catch(function (error) {
        })
    },

    // 修改
    edit (row) {
      this.showDialog = true
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },

    // 删除当前行
    //    handleDelte (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/order/delete', { id: id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },
    // 导出
    async toExport () {
      try {
        // 构建请求数据
        const _data = { ...this.queryInfo.condition }
        // 发送 POST 请求获取文件下载链接
        const res = await this.$http.post(
          '/exportExcel/exportSalesStatistics',
          _data
        )

        // 检查 HTTP 状态码和业务状态码
        if (
          res.status === 200 &&
          res.data.code === 200 &&
          res.data.data.code === '1'
        ) {
          // 获取文件下载链接
          const fileUrl = res.data.data.data // 注意这里需要访问 data 下的 data 属性
          window.open(fileUrl, '_blank')
        } else {
          throw new Error(
            `API error! code: ${res.data.code}, message: ${
              res.data.message || '未知错误'
            }`
          )
        }
      } catch (error) {
        // 捕获并处理所有错误
        console.error('Error exporting sales statistics:', error)
        this.$message.error(`导出失败: ${error.message || '未知错误'}`)
      }
    },

    // 新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },

    showOrderItemInfo (row) {
      this.dialogOrderItemVisible = true
      this.orderItemData = row.orderItems
      console.log('------订单详情----------')
      console.log(row)
      console.log('------订单详情----------')
      this.orderInfo = row
    },

    getPayType (patType) {
      if (patType === '1') {
        return '微信'
      } else if (patType === '2') {
        return '支付宝'
      } else if (patType === '3') {
        return '余额'
      } else if (patType === '4') {
        return '储值卡'
      } else if (patType === '1,5') {
        return '微信+积分'
      } else if (patType === '1,3') {
        return '微信+余额'
      } else if (patType === '1,4') {
        return '微信+储值卡'
      } else if (patType === '2,5') {
        return '支付宝+积分'
      } else if (patType === '2,3') {
        return '支付宝+余额'
      } else if (patType === '2,4') {
        return '支付宝+储值卡'
      } else if (patType === '3,5') {
        return '余额+积分'
      } else if (patType === '4,5') {
        return '储值卡+积分'
      } else if (patType === '6') {
        return '企业月付'
      }
    },
    handleClick (tab, event) {
      //   console.log("tab:",tab.name);
      // console.log("event:",event);
      // console.log(tab, event);
      if (tab.name === 'second') {
        this.getOrderProhress()
      }
    },

    /**
     * 获取订单进度
     *
     */
    getOrderProhress () {
      var that = this
      var data = {}
      data.orderNumber = this.orderInfo.orderNumber
      that.$http
        .post('/orderProgress/queryList', data)
        .then(function (response) {
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.orderProgressData = response.data.data
          }
        })
    },
    getMenuList () {
      var that = this
      that.$http
        .post('/productCategory/queryList', { level: 1 })
        .then((response) => {
          console.log(response.data.data)
          if (response.data.code == 200) {
            response.data.data.forEach((item) => {
              item.value = item.categoryName
            })
            this.menuList = response.data.data
          }
        })
    },
    getSecondLevelCategories (categoryCode) {
      if (!categoryCode) return // 如果没有选中任何一级分类，则不进行查询

      this.$http
        .post('/productCategory/queryList', { parentCode: categoryCode })
        .then((response) => {
          if (response.data.code === 200) {
            this.secondLevelMenuList = response.data.data
          }
        })
    },

    reset () {
      this.queryInfo.condition = {}
      this.value1 = ''
      this.getList()
    }
  }
}
</script>

<style scoped>
.tabTop {
  display: flex;
  justify-content: flex-end;
}
</style>
